import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import level from './modules/level'
import grade from './modules/grade'
import give from './modules/give'
import publicUrl from './modules/publicUrl'
import simulation from './modules/simulation'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    level,
    grade,
    give,
    publicUrl,
    simulation,
  },
})
